/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createListSalesRepDevicesResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type ListSalesRepDevicesResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/salesreps/{salesRepId}/devices
 */
export interface DevicesRequestBuilder extends BaseRequestBuilder<DevicesRequestBuilder> {
    /**
     * Lists the devices a sales rep has checked in from, most recently seen first.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ListSalesRepDevicesResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ListSalesRepDevicesResponse | undefined>;
    /**
     * Lists the devices a sales rep has checked in from, most recently seen first.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const DevicesRequestBuilderUriTemplate = "{+baseurl}/api/organizations/salesreps/{salesRepId}/devices";
/**
 * Metadata for all the requests in the request builder.
 */
export const DevicesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: DevicesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createListSalesRepDevicesResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
